import { EntityDataStore } from '@skinsoft/entity-data-store';
import { TranslatedString } from '@skinsoft/i18n';
import { Alias } from '../..';

export interface Authority {
    id: string;
    authorityCS: any;
    alias: Alias[]
}

export class AuthorityDataStore extends EntityDataStore<Authority> {
    public static getInstance() {
        if (!AuthorityDataStore.instance) {
            AuthorityDataStore.instance = new AuthorityDataStore();
        }

        return AuthorityDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$AuthorityDataStore = AuthorityDataStore.getInstance();
        Vue.prototype.$collaboratorDataStore = AuthorityDataStore.getInstance();
    }

    private static instance: AuthorityDataStore = null as any;

    constructor() {
        super('authorities', ['authority']);
    }
}


